module.exports = __webpack_public_path__ + "img/DE00462.f17e79f2.png";